<template>
  <div :class="$style.container" @click="$emit('click')">
    <div :class="$style.content">
      <div :class="$style.information">
        <div :class="$style.label">{{ label }}</div>
        <div :class="$style.value">{{ value }}</div>
      </div>
      <div :class="$style.action">
        <cs-button type="secondary">
          {{ $t('common.change') }}
        </cs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectablingPanel',
  props: {
    value: String,
    label: String,
  },
};
</script>

<style lang="sass" module>
  .container
    background: rgba(39, 40, 60, 0.5)
    border-radius: 5px
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)

    &:hover
      background: #2F3049

  .content
    display: flex
    align-items: center
    justify-content: space-between
    padding: 20px
    cursor: pointer

  .information
    overflow: hidden

  .action

  .label
    font-weight: 400
    font-size: 14px
    line-height: 17px
    color: rgba(255, 255, 255, .5)

  .value
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
</style>
